import { useNavigate } from "@tanstack/react-router";
import type { ReactNode } from "react";

import { Page, Tabs } from "@/components/ui";

import type { SpaceRow } from "../types";

import { SPACE_TAB_IDS, SPACE_TAB_LABELS, SPACE_TAB_ROUTES, type SpaceTab } from "./tabs";

/** The space level, inside the account shell. Six tabs, each its own address. */
export function SpaceLayout({
  space,
  tab,
  children,
}: {
  readonly space: SpaceRow;
  readonly tab: SpaceTab;
  readonly children: ReactNode;
}) {
  const navigate = useNavigate();
  const joinCode = space.space.join_code;

  return (
    <Page
      eyebrow="Spaces"
      measure={tab === "control" ? "full" : "default"}
      title={space.space.name ?? space.space.join_code}
      tabs={
        <Tabs
          label="Space"
          value={tab}
          onChange={(next: string) => {
            void navigate({ to: SPACE_TAB_ROUTES[next as SpaceTab], params: { joinCode } });
          }}
          tabs={SPACE_TAB_IDS.map((id) => ({ id, label: SPACE_TAB_LABELS[id] }))}
        />
      }
    >
      {children}
    </Page>
  );
}
